import React from 'react';
import { ContainerContextSubscriber } from '@atlassian/jira-providers-container-context/src/main.tsx';
import { isProjectContext } from '@atlassian/jira-providers-container-context/src/types.tsx';
import { subProductFromProjectTypeForAnalytics } from '@atlassian/jira-subproduct/src/index.tsx';
import { SubProductUpdater } from '../sub-product-updater/index.tsx';

export const ProjectSubProductUpdater: Flow.AbstractComponent<{
	allowMonolithDeferral?: boolean;
}> = ({ allowMonolithDeferral = false }) => (
	<ContainerContextSubscriber>
		{({ data }) => (
			<>
				{data && isProjectContext(data) && (
					<SubProductUpdater
						subProduct={subProductFromProjectTypeForAnalytics(data.project.type)}
						allowMonolithDeferral={allowMonolithDeferral}
					/>
				)}
			</>
		)}
	</ContainerContextSubscriber>
);
